module.exports = __webpack_public_path__ + "img/0004.d628d2a3.jpg";